import { post } from './client';
import { buildPath, toJson } from './utils';
import { UPLOAD_PATH } from './constants';

export const upload = (options: any): Promise<any> => post(buildPath(UPLOAD_PATH), options).then(toJson);
